module.exports = __webpack_public_path__ + "img/b4.65bd2d86.png";